module.exports = __webpack_public_path__ + "static/media/YPay.3a97199a.png";